import { createFileRoute, redirect } from '@tanstack/react-router';
import { AppLayout } from '@/shared/layout/AppLayout';

/**
 * Pathless layout route: everything nested under it requires a session and
 * renders inside the app chrome. The check runs before any child loader, so a
 * signed-out user never triggers an API call that would just 401.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
  component: AppLayout,
});
